module.exports = __webpack_public_path__ + "static/media/settings.e6085f72.svg";